<template>
  <div>
    <v-data-table :items="rulesTestResult" hide-headers :hide-actions="rulesTestResult.length <= 5" class="mt-1">
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded" class="pointer">
          <td class="text-xs-left" width="95%">
            <v-icon color="success" v-if="props.item.status === 'SUCCESS'" small class="mr-2 font-weight-bold">done
            </v-icon>
            <v-icon color="warning" v-else-if="props.item.status === 'NOT_ATTEMPTED'" small
              class="mr-2 font-weight-bold">warning</v-icon>
            <v-icon color="error" v-else small class="mr-2 font-weight-bold">clear</v-icon>
            {{ props.item.title }} - {{ props.item.message }}
            <span v-if="props.item.status === 'NOT_ATTEMPTED'">
              (Not Attempted)
            </span>
          </td>
          <td class="text-xs-left" width="5%">
            <v-btn flat icon color="primary" @click.stop="props.expanded = !props.expanded">
              <v-icon>{{
                  props.expanded ? "remove_circle" : "add_circle"
              }}</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <!-- Expanded view-->
      <template slot="expand" slot-scope="props">
        <!-- Condtions -->
        <v-container column v-if="
          props.item.conditionResults &&
          props.item.conditionResults.length > 0
        ">
          <v-flex xs12>
            <h2 class="body-2 ttu caption pa-2">CONDITIONS</h2>
          </v-flex>
          <v-flex xs12>
            <v-data-table hide-actions hide-headers :items="props.item.conditionResults">
              <template slot="items" slot-scope="props">
                <tr class="ml-3 indigo lighten-5">
                  <td class="text-xs-left" width="40%">
                    <v-icon color="success" v-if="props.item.status === 'TRUE'" small class="mr-2 font-weight-bold">done
                    </v-icon>
                    <v-icon color="error" v-else small class="mr-2 font-weight-bold">clear</v-icon>
                    {{ props.item.title }}
                  </td>
                  <td class="text-xs-left" width="20%">
                    {{ props.item.status }}
                  </td>
                  <td class="text-xs-left" width="40%">
                    {{ props.item.messages.join("\n") }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-container>
        <!-- Actions -->
        <v-container column v-if="props.item.actionResults && props.item.actionResults.length > 0">
          <v-flex xs12>
            <h2 class="body-2 ttu caption pa-2">ACTIONS</h2>
          </v-flex>
          <v-flex xs12>
            <v-data-table hide-actions hide-headers :items="props.item.actionResults">
              <template slot="items" slot-scope="props">
                <tr class="indigo lighten-5 ml-3">
                  <td class="text-xs-left" width="40%">
                    <v-icon color="success" v-if="
                      props.item.status === 'TRUE' ||
                      props.item.status === 'SUCCESS'
                    " small class="mr-2 font-weight-bold">done</v-icon>
                    <v-icon color="error" v-else small class="mr-2 font-weight-bold">clear</v-icon>
                    {{ props.item.title }}
                  </td>
                  <td class="text-xs-left" width="20%">
                    {{ props.item.status }}
                  </td>
                  <td class="text-xs-left" width="40%">
                    {{ props.item.message }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-container>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  name: "XVATRuleTestResultView",
  props: ["rulesTestResult"],
  data() {
    return {}
  },
  methods: {
    /**
     * showExpandIcon
     * @param {object} item
     * @returns {boolean}
     */
    showExpandIcon(item) {
      if (
        (item.actionResults && item.actionResults.length > 0) ||
        (item.conditionResults && item.conditionResults.length > 0)
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/XVAT/XVATRuleTestResultView.vue